import { render, staticRenderFns } from "./content-editable.vue?vue&type=template&id=f939d074&scoped=true&"
import script from "./content-editable.vue?vue&type=script&lang=js&"
export * from "./content-editable.vue?vue&type=script&lang=js&"
import style0 from "./content-editable.vue?vue&type=style&index=0&id=f939d074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f939d074",
  null
  
)

export default component.exports